<template>
  <div>
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <table width="100%" class="mb-2">
        <thead>
          <th>Kode TTB</th>
          <th>No TTB</th>
          <th>Tgl</th>
          <th>Pengirim</th>
          <th>Penerima</th>
          <th>Kode Kapal</th>
          <th>Tgl Berangkat</th>
        </thead>
        <tbody>
          <tr v-for="ttb in data" :key="ttb.id">
            <td>{{ ttb.kodettb }}</td>
            <td>{{ ttb.nottb }}</td>
            <td>{{ formatDate(ttb.tgl) }}</td>
            <td>
              {{
                ttb.pengirim_detil
                  ? ttb.pengirim_detil.nama_lengkap || "-"
                  : "-"
              }}
            </td>
            <td>
              {{
                ttb.penerima_detil
                  ? ttb.penerima_detil.nama_lengkap || "-"
                  : "-"
              }}
            </td>
            <td>{{ ttb.kode_kapal || "-" }}</td>
            <td>{{ formatDate(ttb.tgl_berangkat) }}</td>
          </tr>
        </tbody>
      </table>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      data: []
    };
  },
  methods: {
    async fetchData() {
      this.state.loading = true;

      await axios
        .get(`laporan/ttb-belum-ada-nota`)
        .then(res => {
          if (res.data.length <= 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;
          alert(err.response?.data?.message || "Gagal memuat laporan");
        });
    },
    formatDate(date) {
      if (!date) return "-";
      const newDate = new Date(date);
      return newDate.toLocaleDateString("id-ID", {
        day: "numeric",
        month: "short",
        year: "numeric"
      });
    },
    printDocument() {
      window.print();
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header .left {
  width: 80%;
}

.header .right {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right p {
  font-size: 12px;
}

.report-info {
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
}

.report-info p {
  font-style: italic;
}

.report-info .kv {
  padding: 0 5px;
  height: fit-content;
  border: 1px solid black;
}

table {
  border-bottom: 1px solid black;
}

table th {
  text-align: left;
}

footer {
  display: flex;
  justify-content: space-between;
}

.sign p {
  margin-right: 150px;
}

@media print {
  #section-print {
    display: block !important;
  }
}
</style>
